export const FRONTEND_VERSION = "7.3.2";
